export enum PanelOption {
    releases = 1,
    recaptures = 2,
    catches = 3
}